import React, { useState } from "react";
import {
    Card,
    Typography,
    CardContent,
    Grid,
    Collapse,
} from "@material-ui/core";
import {
    ArrowUpward as UpIcon,
    ArrowDownward as DownIcon,
} from "@material-ui/icons";
import { CardHeader } from "reactstrap";

function ComponentTemplate({
    label = "Page Title",
    isCollapsed = false,
    children,
    isCollapsable = true,
}) {
    const [collapsed, setCollapsed] = useState(isCollapsed);
    return (
        <Card style={{ border: "2px solid #0188cc", background: "#0188cc" }}>
            <CardHeader style={{ background: "#0188cc" }}>
                <Grid container spacing={0}>
                    <Grid item xs={6}>
                        <Typography variant="h6" style={{ color: "white" }}>
                            {label}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        {isCollapsable && (
                            <div
                                style={{
                                    float: "right",
                                    color: "white",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                }}
                                onClick={() => setCollapsed((ev) => !ev)}
                            >
                                {collapsed ? <DownIcon /> : <UpIcon />}
                            </div>
                        )}
                    </Grid>
                </Grid>
            </CardHeader>
            <CardContent
                style={{
                    background: "white",
                    height: "auto",
                    padding: 0,
                }}
            >
                <Collapse in={!collapsed}>
                    <div style={{ padding: 12 }}>{children}</div>
                </Collapse>
            </CardContent>
        </Card>
    );
}

export default ComponentTemplate;
